// 書き出し: 表示と同じ Compositor で合成し、readPixels で取り出す。

import type { Document } from '@/types/document'
import type { Compositor } from './compositor'

export interface ExportedPixels {
  width: number
  height: number
  /** ストレートアルファ RGBA、行順 = 文書行順 */
  rgba: Uint8ClampedArray
}

export function renderDocumentToPixels(compositor: Compositor, doc: Document): ExportedPixels {
  const { width, height } = compositor.render(doc)
  const rgba = compositor.readPixels({ x: 0, y: 0, w: width, h: height })
  return { width, height, rgba }
}
